module.exports = __webpack_public_path__ + "assets/img/artificial.1bc5f0f3.png";